import { LuPlus } from "react-icons/lu";
import { useNavigate } from "react-router-dom";
import {
  SideMenuBehavior,
  useSideMenuActions,
  useSideMenuBehavior,
} from "../../../view_stores/useSideMenuStore";
import { PrimaryButton } from "../../common_components/Buttons";

export default function SideMenuStartNewProjectBtn() {
  const { close: closeSideMenu } = useSideMenuActions();
  const sideMenuBehavior = useSideMenuBehavior();
  const navigate = useNavigate();

  const onClick = () => {
    if (sideMenuBehavior === SideMenuBehavior.AUTO) {
      window.dispatchEvent(new Event("darvin-block-reopen-menu"));
      closeSideMenu();
    }
    navigate("/", {
      state: {
        focusTextField: true,
      },
      replace: true,
    });
  };

  return (
    <PrimaryButton
      onClick={onClick}
      label="Start new project"
      icon={<LuPlus size={24} />}
      align="left"
    />
  );
}
